import { MktuClassCategory } from '@/models/Mktu'
import { apiService } from '@/services/Api'
import { MktuClassStore } from '@/store/Mktu/MktuClass.store'

export function getTypeMktuClassByNumber(number: number) {
  if (number <= 34) {
    return MktuClassCategory.Product
  } else {
    return MktuClassCategory.Service
  }
}

export async function exportMktuListToFile(list: MktuClassStore[]) {
  const response = await apiService.mktu._exportRaw({
    exportRequest: {
      mktuList: list.map((c) => ({
        classNumber: c.data.classNumber,
        selectedWords: c.selectedWords.map((w) => w.word),
      })),
    },
  })

  const { format } = await import('@/utils/date')

  const contentDisposition = response.raw.headers.get('Content-Disposition')
  let filename = `brandside_export_${format(
    new Date(),
    'DD.MM.YYYY_HH.mm'
  )}.txt`
  if (contentDisposition) {
    const match = contentDisposition.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    )
    if (match && match[1]) {
      filename = match[1].replace(/['"]/g, '')
    }
  }

  const blob = await response.raw.blob()
  const blobUrl = window.URL.createObjectURL(blob)

  const element = document.createElement('a')
  element.setAttribute('href', blobUrl)
  element.setAttribute('download', filename)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()

  // Очистка
  document.body.removeChild(element)
  window.URL.revokeObjectURL(blobUrl)
}
